import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { CTA, TICKETS } from "@/content/galaxy";

export const CTABand = () => {
  return (
    <section
      data-testid="cta-section"
      className="relative z-10 py-24 md:py-28"
    >
      <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
        <Reveal>
          <div className="relative overflow-hidden rounded-3xl border border-white/12 glass px-6 py-14 text-center shadow-[0_0_0_1px_rgba(58,123,255,0.10),0_30px_80px_rgba(0,0,0,0.45)] sm:px-12 sm:py-16">
            <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(620px_circle_at_50%_-10%,rgba(58,123,255,0.24),transparent_62%)]" />

            <span className="relative font-mono-accent text-xs uppercase tracking-[0.3em] text-gl-blue2">
              {CTA.badge}
            </span>
            <h2 className="relative mx-auto mt-4 max-w-2xl font-display text-3xl font-extrabold uppercase leading-[1.05] tracking-tight text-white sm:text-5xl">
              {CTA.headline}
            </h2>
            <p className="relative mx-auto mt-5 max-w-xl text-sm leading-relaxed text-white/65 sm:text-base">
              {CTA.text}
            </p>

            <a
              href={TICKETS.url}
              data-testid="cta-tickets-button"
              className="group relative mt-8 inline-flex items-center justify-center gap-2 rounded-full bg-brand-gradient px-8 py-3.5 text-sm font-semibold tracking-wide text-white glow-md transition-[filter,transform] duration-200 hover:-translate-y-0.5 hover:brightness-110 active:scale-[0.98]"
            >
              {CTA.button}
              <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" />
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
